export const LOGO_LINK_TEST_ID = {
  logo: 'logo',
};
